import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

import {API_URL} from './constants';

export const baseApi = createApi({
  keepUnusedDataFor: 0, // Keep cache for 5 minutes
  refetchOnMountOrArgChange: 5, // Always refetch on mount
  refetchOnReconnect: true, // Refetch when reconnecting to network
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers, {getState}) => {
      const token = (getState() as any).login.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});
